export default (() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-fetch-apply-coupon').forEach((el) => {
      el.addEventListener('click', (event) => {
        event.preventDefault()
        event.stopPropagation()
        const input = document.querySelector(el.dataset.couponCodeInput)
        if (!input) {
          return false
        }
        // POST /ec/cart/fetch_apply_coupon
        //   form_data:
        //     coupon_code=123456
        const formData = new FormData()
        formData.append('coupon_code', input.value)
        fetch('/ec/cart/fetch_apply_coupon.json', {
          method: 'POST',
          body: formData,
        }).then((res) => {
          res.json().then((data) => {
            //console.log(data)
            document.dispatchEvent(
              new CustomEvent('odims:coupon:fetch_apply', {
                detail: data,
              })
            )
          })
        })
      })
    })
  })
})()
